import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export function KpiSkeleton({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="h-[110px] rounded-[14px]" />
      ))}
    </div>
  );
}

export function BlockSkeleton({ className = "h-72" }) {
  return <Skeleton className={`w-full rounded-[14px] ${className}`} />;
}
